export const POINTER_HORIZONTAL_SCROLL_DELAY = 200;
export const FOCUSED_ITEM_CENTER_DELAY = 100;
export const FOCUSED_ITEM_PREVENT_SCROLL_OFFSET = 150;
